import { GAME_STORE_DEFAULTS } from '@GameStore/GameStoreDefaults';
import { TSceenBreakpoints } from '@Managers/Device/UseWindowDimensions.types';
import { EGameStates } from '@Managers/StateManager/GameStates';
import { FixStateDefault } from '@UILayer/Modules/DebugTool/Modules/Fixes/Fixes.types';
import { AppState } from './AppState.types';

export const initialState: AppState = {
    init: false,
    maintananceMode: {
        active: false,
        time: undefined,
        startAt: '',
        plannedEndAt: ''
    },
    gameStore: GAME_STORE_DEFAULTS,
    wcaMode: false,
    loggedOut: false,
    readyState: false,
    canvasReady: false,
    leftHandMode: false,
    popupPanel: false,
    menuPages: false,
    debugTools: false,
    inGameHistoryMode: false,
    device: {
        docHeight: 0,
        docWidth: 0,
        appHeight: 0,
        appWidth: 0,
        appTopOffset: 0,
        appRightOffset: 0,
        appLeftOffset: 0,
        appBottomOffset: 0,
        windowOrientation: '',
        windowOrientationPortrait: false,
        windowOrientationHorizontal: false,
        fullScreen: false,
        isMobile: true,
        screenSize: TSceenBreakpoints.xs,
        isiOS: false,
        aspectRatio: 0,
        uiMaxCoverage: 0,
        isTabletHorizontal: false,
        isTabletPortrait: false
    },
    globalStyles: {
        orientation: {},
        device: {},
        wcaMode: {},
        handMode: {},
        wideDevice: {},
        screenSize: {},
        balanceFontSize: 0,
        settingsBaseFontSize: 0,
        isTablet: {}
    },
    popupMessage: undefined,
    fixesState: FixStateDefault,
    gamePerformance: {
        targetFps: 0,
        actualFps: 0,
        fpsVsTarget: '',
        deltaVsTarget: '',
        frame: 0,
        delta: 0,
        rawDelta: 0
    },
    uiState: {
        visible: false,
        uiFreeze: false
    },
    casinoMenu: {},
    currentGameState: EGameStates.IDLE_STATE,
    popClient: {
        enabled: false,
        initialized: false,
        supportedFeatures: {}
    },
    inGameHistoryPage: {
        active: false,
        url: ''
    }
};
